'use strict';

function isISODatePartWithoutYear(datePart) {
  return datePart.startsWith("-");
}

module.exports = isISODatePartWithoutYear;
//# sourceMappingURL=isISODatePartWithoutYear.cjs.map
